exports.components = {
  "component---src-new-heating-templates-boxt-heating-js": () => import("./../../../src-new-heating/templates/boxt-heating.js" /* webpackChunkName: "component---src-new-heating-templates-boxt-heating-js" */),
  "component---src-new-heating-templates-landing-page-js": () => import("./../../../src-new-heating/templates/landing-page.js" /* webpackChunkName: "component---src-new-heating-templates-landing-page-js" */),
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */)
}

